// types/tables/tables.ts
import { z } from "zod";
var FieldTypeEnum = z.enum([
  "string",
  "labeled_string",
  "text",
  "boolean",
  "number",
  "decimal",
  "datetime",
  "json",
  "email",
  "link",
  "currency",
  "phone_number",
  //"uuid" - this one leads to weird "not implemented" issues
  // "multiple_string",
  // "multiple_labeled_string",
  // "multiple_text",
  // "multiple_boolean",
  // "multiple_number",
  // "multiple_decimal",
  // "multiple_datetime",
  // "multiple_uuid",
  // "multiple_json",
  // "formula",
  // "button_trigger_zap",
  // "button_continue_zap",
  // "multiple_email",
  // "ai_formula",
  "linked_record"
  // "multiple_linked_record",
]).describe(
  "Use labeled_string to support choice_providers if you are using a dropdown interface."
);
var icons = z.enum([
  "actionAttachment",
  "actionAutoRenew",
  "actionBookmark",
  "actionBookmarkFill",
  "actionBug",
  "actionBugFill",
  "actionBuild",
  "actionCalendar",
  "actionCalendarFill",
  "actionCamera",
  "actionCameraFill",
  "actionCheckConnection",
  "actionCheckConnectionFill",
  "actionCompare",
  "actionCopy",
  "actionCopyFill",
  "actionDownload",
  "actionDrag",
  "actionEdit",
  "actionEditAi",
  "actionEditAiFill",
  "actionEditCircle",
  "actionEditCircleFill",
  "actionEditFill",
  "actionEmail",
  "actionEmailFill",
  "actionExplore",
  "actionExploreFill",
  "actionFallback",
  "actionFilter",
  "actionFlag",
  "actionFlagFill",
  "actionInsert",
  "actionLink",
  "actionLock",
  "actionLockFill",
  "actionMoveToFolder",
  "actionMoveToFolderFill",
  "actionPhoto",
  "actionPhotoFill",
  "actionPin",
  "actionPinFill",
  "actionPlay",
  "actionPlayFill",
  "actionRename",
  "actionReadAloud",
  "actionReadAloudFill",
  "actionRenameFill",
  "actionResend",
  "actionResendFill",
  "actionSend",
  "actionSendFill",
  "actionShare",
  "actionShareFill",
  "actionSwitchAccount",
  "actionSwitchAccountFill",
  "actionTrash",
  "actionTrashFill",
  "actionUpload",
  "actionZapDetails",
  "actionZapDetailsFill",
  "alertCircle",
  "alertCircleFill",
  "alertCircleColor",
  "alertInfo",
  "alertInfoFill",
  "alertTriangle",
  "alertTriangleFill",
  "arrowBigDown",
  "arrowBigLeft",
  "arrowBigRight",
  "arrowBigUp",
  "arrowBranch",
  "arrowCode",
  "arrowCodeDots",
  "arrowConnect",
  "arrowContract",
  "arrowDropdown",
  "arrowDropdownCircle",
  "arrowExit",
  "arrowExpand",
  "arrowLineLeft",
  "arrowLineRight",
  "arrowOffsite",
  "arrowRedo",
  "arrowRefresh",
  "arrowResizeDiagonalLeft",
  "arrowResizeDiagonalRight",
  "arrowResizeHorizontal",
  "arrowSmallDown",
  "arrowSmallLeft",
  "arrowSmallRight",
  "arrowSmallUp",
  "arrowUndo",
  "arrowZoom",
  "commentAdd",
  "commentAddFill",
  "commentBlank",
  "commentBlankFill",
  "commentConvo",
  "commentConvoFill",
  "commentFilled",
  "commentFilledFill",
  "commentWaiting",
  "commentWaitingFill",
  "fileAdd",
  "fileAddFill",
  "fileFile",
  "fileFileFill",
  "fileFilled",
  "fileFilledFill",
  "fileGuide",
  "fileGuideFill",
  "fileRemove",
  "fileRemoveFill",
  "formAdd",
  "formAddCircle",
  "formAddCircleOutlined",
  "formAddSquare",
  "formAddSquareOutlined",
  "formBlank",
  "formCheck",
  "formCheckCircle",
  "formCheckCircleOutlined",
  "formCheckSquare",
  "formCheckSquareOutlined",
  "formDash",
  "formDashCircle",
  "formDashCircleOutlined",
  "formDashSquare",
  "formDashSquareOutlined",
  "formRadioCheck",
  "formRadioDot",
  "formRadioUnchecked",
  "formText",
  "formTextLong",
  "formTextAlignCenter",
  "formTextAlignLeft",
  "formTextAlignRight",
  "formToggle",
  "formX",
  "formXCircle",
  "formXCircleOutlined",
  "miscAI",
  "miscAIFill",
  "miscBolt",
  "miscBoltAlt",
  "miscBoltAltFill",
  "miscBoltFill",
  "miscBoltOutlined",
  "miscBundle",
  "miscClock",
  "miscClockFill",
  "miscClockPlay",
  "miscCloud",
  "miscCloudCheck",
  "miscCloudCheckFill",
  "miscCloudFill",
  "miscColor",
  "miscColorFill",
  "miscCookie",
  "miscCookieFill",
  "miscCreditCard",
  "miscCreditCardFill",
  "miscDollar",
  "miscErrorHandler",
  "miscEye",
  "miscEyeClosed",
  "miscEyeFill",
  "miscFingerprint",
  "miscFire",
  "miscFireFill",
  "miscGraph",
  "miscGraphBox",
  "miscGraphBoxFill",
  "miscHand",
  "miscHandFill",
  "miscHeadset",
  "miscHeadsetFill",
  "miscLearn",
  "miscLearnFill",
  "miscList",
  "miscMic",
  "miscMicFill",
  "miscPackage",
  "miscPie",
  "miscPieFill",
  "miscPin",
  "miscPinFill",
  "miscSecurity",
  "miscSecurityFill",
  "miscSteps",
  "miscSteps1",
  "miscSteps2",
  "miscSteps3",
  "miscStepsAlt",
  "miscStepsFill",
  "miscTimelapse",
  "miscTrigger",
  "miscUptime",
  "miscUptimeFill",
  "miscWallet",
  "miscWalletFill",
  "miscWorld",
  "miscWorldFill",
  "navAIChatbot",
  "navApps",
  "navAppsFill",
  "navBell",
  "navBellFill",
  "navBlog",
  "navBlogFill",
  "navBriefcase",
  "navBriefcaseFill",
  "navCanvas",
  "navCentral",
  "navCog",
  "navCogFill",
  "navConnectedAssets",
  "navConnectedAssetsFill",
  "navCustomAction",
  "navDashboard",
  "navDashboardFill",
  "navExplore",
  "navExploreFill",
  "navFolder",
  "navFolderFill",
  "navFunctions",
  "navGridView",
  "navHelp",
  "navHelpFill",
  "navHome",
  "navHomeFill",
  "navIntegrations",
  "navIntegrationsFill",
  "navInterfaces",
  "navMenu",
  "navMenuAlt",
  "navMoreHoriz",
  "navMoreVert",
  "navProductHub",
  "navProjects",
  "navProjectsFill",
  "navSearch",
  "navSearchFill",
  "navTable",
  "navTables",
  "navTableFill",
  "navVersions",
  "navVersionsFill",
  "zapierLogo",
  "partnerDashboard",
  "partnerEmbed",
  "personAdd",
  "personAddFill",
  "personCircle",
  "personCircleFill",
  "personGroup",
  "personGroupFill",
  "personOne",
  "personOneFill",
  "personSettings",
  "ratingCool",
  "ratingHappy",
  "ratingHappyAlt",
  "ratingHeart",
  "ratingHeartFill",
  "ratingNeutral",
  "ratingNeutralAlt",
  "ratingSad",
  "ratingSadAlt",
  "ratingStar",
  "ratingStarFill",
  "ratingThumbsBoth",
  "ratingThumbsBothFill",
  "ratingThumbsDown",
  "ratingThumbsDownFill",
  "ratingThumbsUp",
  "ratingThumbsUpFill",
  "ratingVeryHappy",
  "ratingVeryHappyAlt",
  "ratingVerySad",
  "ratingVerySadAlt",
  "ratingWink",
  "ratingWinkAlt",
  "statusFilter",
  "statusFilterFill",
  "statusPaused",
  "statusPlaying",
  "statusPlayingFill",
  "statusStatus",
  "statusStatusFill",
  "statusStop",
  "statusStopFill",
  "team",
  "teamFill"
]).describe(
  "These icons should be used for the table columns next to the field title. If there is no obvious icon, fallback to a form-prefixed ones."
);
var ChoiceProviderSchema = z.object({
  kind: z.literal("static"),
  choices: z.array(
    z.object({
      label: z.string(),
      value: z.string()
    })
  )
});
var TemplateTableSchema = z.object({
  id: z.string(),
  name: z.string(),
  fields: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      type: FieldTypeEnum,
      options_indexed: z.literal(false),
      options_required: z.literal(false),
      options_read_only: z.boolean(),
      options_include_time: z.boolean().describe("Only use with datetime field types."),
      options_timezone: z.literal("America/New_York"),
      options_date_format: z.string().describe("Use 'yyyy-MM-dd' if this is a date column"),
      options_time_format: z.string(),
      options_icon: icons,
      options_alignment: z.enum(["left", "center", "right"]),
      options_decimals: z.number(),
      options_currency_format: z.string(),
      options_phone_number_format: z.string(),
      options_description: z.string(),
      options_choice_provider: ChoiceProviderSchema.describe(
        'Only use with "labeled_string" fields to support dropdowns'
      )
    })
  )
});
var ModifiedFieldSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  options: z.object({
    indexed: z.boolean().optional(),
    required: z.boolean().optional(),
    read_only: z.boolean().optional(),
    include_time: z.boolean().optional(),
    timezone: z.string().optional(),
    date_format: z.string().optional(),
    time_format: z.string().optional(),
    icon: z.string().optional(),
    alignment: z.string().optional(),
    decimals: z.number().optional(),
    currency_format: z.string().optional(),
    phone_number_format: z.string().optional(),
    description: z.string().optional(),
    choice_provider: z.object({
      kind: z.literal("static"),
      choices: z.array(
        z.object({
          label: z.string(),
          value: z.string()
        })
      )
    }).optional()
  }).optional()
});
var ModifiedTableSchema = z.object({
  id: z.string(),
  name: z.string(),
  fields: z.array(ModifiedFieldSchema)
});

export {
  FieldTypeEnum,
  TemplateTableSchema,
  ModifiedFieldSchema,
  ModifiedTableSchema
};
